import { deleteArticles } from './deleteArticles.js'

export const verification = () => {
  const el = document.querySelector('.age-verification')
  const inner = el.querySelector('.inner')
  const fields = el.querySelector('.fields-inner')
  const yearInputs = el.querySelectorAll('.year-field')
  const monthInputs = el.querySelectorAll('.month-field')
  const dayInputs = el.querySelectorAll('.day-field')
  const error = el.querySelector('.error')
  const button = el.querySelector('button')
  const englandRadioButton = el.querySelector('#england-and-wales')
  const scotlandandWalesRadioButton = el.querySelector('#scotland')

  let inputYear = []
  let inputMonth = []
  let inputDay = []
  let location = null
  let verificationStatus = null

  let locationCookie = getCookieValue('thlocation')
  let accessCookie = getCookieValue('thaccess')

  if ((locationCookie && accessCookie) || sessionStorage.getItem('verified')) {
    el.remove()
    document.body.classList.remove('locked')
    deleteArticles()
  } else {
    el.style.opacity = 1
  }

  yearInputs.forEach((input, i) => {
    input.addEventListener('keydown', (e) => {
      if (isNaN(e.key) && e.key != 'Backspace') return

      setTimeout(() => {
        const nextField = input.nextElementSibling
        const prevField = input.previousElementSibling

        if (e.key == 'Backspace') {
          if (prevField) prevField.value = ''
          if (prevField) prevField.focus()
          inputYear.splice(i, 1)
        } else {
          if (nextField) nextField.value = ''
          if (nextField) nextField.focus()
          inputYear[i] = e.target.value
        }

        resetValidation()

        if (inputYear.length == 4) {
          checkYear(inputYear)
        }
      }, 50)
    })
  })

  monthInputs.forEach((input, i) => {
    input.addEventListener('keydown', (e) => {
      if (isNaN(e.key) && e.key != 'Backspace') return

      setTimeout(() => {
        const nextField = input.nextElementSibling
        const prevField = input.previousElementSibling
        if (e.key == 'Backspace') {
          if (prevField) prevField.value = ''
          if (prevField) prevField.focus()
          if (!prevField) {
            yearInputs[3].value = ''
            yearInputs[3].focus()
            fields.setAttribute('data-show', 'year')
          }
          inputMonth.splice(i, 1)
        } else {
          if (nextField) nextField.focus()
          inputMonth[i] = e.target.value
        }

        resetValidation()

        if (inputMonth.length == 2) {
          checkMonth(inputMonth)
        }
      }, 50)
    })
  })

  dayInputs.forEach((input, i) => {
    input.addEventListener('keydown', (e) => {
      if (isNaN(e.key) && e.key != 'Backspace') return

      setTimeout(() => {
        const nextField = input.nextElementSibling
        const prevField = input.previousElementSibling

        if (e.key == 'Backspace') {
          if (prevField) prevField.value = ''
          if (prevField) prevField.focus()
          if (!prevField) {
            monthInputs[1].value = ''
            monthInputs[1].focus()
            fields.setAttribute('data-show', 'month')
          }
          inputDay.splice(i, 1)
        } else {
          if (nextField) nextField.focus()
          inputDay[i] = e.target.value
        }

        resetValidation()

        if (inputDay.length == 2) {
          checkDay(inputDay)
        }
      }, 50)
    })
  })

  const checkYear = (userYear) => {
    const date = new Date()
    const year = date.getFullYear()
    const inputYear = Number(userYear.join(''))
    const ageCheck = year - inputYear

    if (ageCheck > 18 && ageCheck < 130) {
      verificationStatus = true
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    } else if (ageCheck == 18) {
      monthInputs[0].focus()
      fields.setAttribute('data-show', 'month')
    } else if (ageCheck <= 18 && ageCheck >= 0) {
      verificationStatus = false
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    } else {
      error.style.display = 'block'
    }
  }

  const checkMonth = (userMonth) => {
    const date = new Date()
    const month = date.getMonth() + 1
    const inputMonth = Number(userMonth.join(''))
    const ageCheck = month - inputMonth

    if (inputMonth > 12 || inputMonth == 0) {
      error.style.display = 'block'
    } else if (ageCheck > 0) {
      verificationStatus = true
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    } else if (ageCheck == 0) {
      dayInputs[0].focus()
      fields.setAttribute('data-show', 'day')
    } else {
      verificationStatus = false
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    }
  }

  const checkDay = (userDay) => {
    const date = new Date()
    const day = date.getDate()
    const inputDay = Number(userDay.join(''))
    const ageCheck = day - inputDay

    if (inputDay > 31 || inputDay == 0) {
      error.style.display = 'block'
    } else if (ageCheck >= 0) {
      verificationStatus = true
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    } else {
      verificationStatus = false
      if (englandRadioButton.checked || scotlandandWalesRadioButton.checked) button.removeAttribute('disabled')
    }
  }

  const resetValidation = () => {
    error.style.display = 'none'
    button.setAttribute('disabled', true)
  }

  button.addEventListener('click', () => {
    if (verificationStatus) {
      passVerification()
    } else {
      failVerification()
    }
  })

  const passVerification = () => {
    el.remove()
    sessionStorage.setItem('verified', true)
    document.body.classList.remove('locked')
    let date = new Date();
    date.setTime(date.getTime() + 86400000);
    document.cookie = "thlocation=" + location + "; " + date.toUTCString() + "; path=/";
    document.cookie = "thaccess=permitted; " + date.toUTCString() + "; path=/";
  }

  const failVerification = () => {
    const hideEl = el.querySelector('.content')
    const messageEl = document.createElement('div')
    const message = `<p>Sorry, you are not old enough to enter this site. <br> Please, come back when you are of legal purchase age. <br> In the meantime, you can know more about <a href="http://www.responsibledrinking.org" target="_blank"> responsible drinking </a>. </p>`
    messageEl.innerHTML = message
    messageEl.classList.add('restricted')
    hideEl.remove()
    inner.appendChild(messageEl)
  }

  [englandRadioButton, scotlandandWalesRadioButton].forEach(radioButton => {
    radioButton.addEventListener('change', () => {
      location = radioButton.value
      document.documentElement.setAttribute('data-location', location)
      if (verificationStatus !== null) button.removeAttribute('disabled')
      if (verificationStatus) passVerification()
      sessionStorage.setItem('location', location)
      deleteArticles()
    })
  })

}

export const getCookieValue = name => {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export default () => { }